
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13337',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13337",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.931",
  "client-types": "static-1.501",
  "data-fetching-client": "static-1.10011",
  "foundations-components": "static-1.8578",
  "foundations-components-legacy": "static-1.1603",
  "foundations-theming": "static-1.4840",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.90",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8397",
  "hub-http-shared-msw-handlers": "static-1.10711",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11851",
  "I18n": "static-7.1681",
  "jasmine-runner": "static-1.6810",
  "marketplace-discovery-studio-lib": "static-1.729",
  "marketplace-storefront-base": "static-1.13400",
  "quartz": "static-1.7530",
  "react-dlb": "static-1.90",
  "react-rhumb": "static-1.17088",
  "reactive-variable-buffer-atom": "static-1.3215",
  "reporting-testing-lib": "static-1.10933",
  "reselect": "static-3.13",
  "settings-ui-lib": "static-1.12885",
  "SharedI18nStrings": "static-1.184",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7702",
  "ui-addon-i18n": "static-1.11510",
  "ui-addon-react-router-dom": "static-1.9892",
  "unified-auth": "static-1.1022",
  "unified-auth-core-lib": "static-1.1304",
  "usage-tracker": "static-1.7674",
  "usage-tracker-core": "static-1.7524",
  "customer-data-property-utils": "static-1.8449",
  "hub-http": "static-1.6573",
  "integrations-lib": "static-1.17181",
  "marketplace-ui-common": "static-1.20848",
  "marketplace-ui-install": "static-1.834",
  "property-management-iframe": "static-1.14242",
  "quartz-config": "static-1.1308",
  "quartz-core": "static-1.6749",
  "quartz-routing": "static-1.960",
  "quick-fetch": "static-1.4160",
  "react": "static-7.199",
  "rpc-client-utils": "static-1.5027",
  "ts-schema": "static-1.4330",
  "ui-universal-auth": "static-1.9508",
  "UIComponents": "static-3.8797",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3807",
  "quartz-webpack": "static-1.3754",
  "bend-plugin-quartz-routing": "static-1.608",
  "ai-components-ui-library": "static-1.9833",
  "codemirror": "static-5.103",
  "foundations-assets": "static-1.5247",
  "pulse": "static-1.993",
  "react-codemirror": "static-1.11004",
  "ui-extensions-preview-lib": "static-1.712",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4847",
  "floating-ui": "static-1.64",
  "foundations-theming-specialty": "static-1.2556",
  "framer-motion": "static-1.80",
  "hs-story-utils": "static-1.9785",
  "react-aria": "static-1.73",
  "react-create-root-preference": "static-1.80",
  "react-select-plus": "static-1.114",
  "react-utils": "static-2.5593",
  "react-virtualized": "static-2.108",
  "StyleGuideUI": "static-3.509",
  "tanstack-table": "static-1.62",
  "trellis-assets": "static-1.2803",
  "ui-fonts": "static-1.1113",
  "ui-images": "static-2.1265",
  "bend-plugin-foundations-theming": "static-1.3323",
  "foundations-theming-base": "static-1.3825",
  "stylex": "static-1.42",
  "HeadJS": "static-2.805",
  "hs-test-utils-bend-plugin": "static-1.3508",
  "msw": "static-1.39",
  "msw-config": "static-1.9",
  "testing-library": "static-1.160",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.92",
  "jasmine": "static-4.4673",
  "ui-addon-video-player": "static-1.9052",
  "ai-rendering-library": "static-1.11200",
  "chirp-fetch": "static-1.2259",
  "connections-embed-lib": "static-1.1591",
  "copilot-toolkit": "static-1.11945",
  "feedback-loader": "static-1.29890",
  "laboratory-lib": "static-3.7514",
  "marketplace-embed": "static-1.23017",
  "marketplace-ui-details": "static-1.10743",
  "marketplace-ui-reviews": "static-1.20803",
  "marketplace-ui-tracking": "static-1.15018",
  "sanitize-text": "static-1.8518",
  "usage-tracker-multi": "static-1.6088",
  "usage-tracker-session-replay": "static-1.5360",
  "wootric-nps": "static-1.7232",
  "quartz-head": "static-1.1195",
  "web-vitals": "static-1.16",
  "apollo-link-hub-http": "static-2.5008",
  "immer": "static-1.102",
  "immerable": "static-1.4506",
  "highcharts": "static-8.112",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2733",
  "reporting-data": "static-1.69000",
  "cssUtils": "static-1.983",
  "flux-actions": "static-1.375",
  "react-colorpicker": "static-2.10575",
  "react-dnd-compat": "static-1.4976",
  "redux-observable": "static-1.76",
  "ReduxMessenger": "static-2.10733",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7664",
  "icons": "static-2.695",
  "marketplace-ui-apps-core": "static-1.19380",
  "storybook-react": "static-1.41",
  "trellis-story-utils": "static-1.4868",
  "foundations-components-test-utils": "static-1.6061",
  "quartz-i18n": "static-1.1205",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.569",
  "ads-unified-auth-lib": "static-1.1587",
  "custom-vendor-connection-lib": "static-1.72",
  "google-sheets-integration-lib": "static-1.1132",
  "microsoft-drive-auth-lib": "static-1.271",
  "surveymonkey-integration-lib": "static-1.608",
  "slack-ui-library": "static-1.10760",
  "fsm": "static-1.4115",
  "customer-data-objects": "static-1.8052",
  "property-translator": "static-1.5742",
  "hs-locale-management": "static-1.332",
  "frontend-preferences-client": "static-1.8282",
  "hs-promise-utils": "static-1.5951",
  "hubspot-apollo-client": "static-1.5236",
  "integrations-error-boundary-lib": "static-1.14596",
  "integrations-tracking-lib": "static-1.5973",
  "native-integrations-shared-strings": "static-1.8127",
  "sanitize": "static-1.4832",
  "superstore": "static-1.5122",
  "ui-shepherd-react": "static-3.10632",
  "ai-settings-ui-library": "static-1.8419",
  "hub-http-janus": "static-1.889",
  "hubspotter-http": "static-1.4896",
  "immutable-less": "static-1.5012",
  "marketplace-ui-client-types": "static-1.18255",
  "nav-meta": "static-1.30574",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18454",
  "ui-product-approvals-common": "static-1.1266",
  "ai-studio-lib": "static-1.12525",
  "hubspot-prosemirror": "static-1.19085",
  "integrations-reconnect-lib": "static-1.564",
  "ui-addon-iframeable": "static-1.9440",
  "ui-addon-integrations-directory-panel": "static-2.8378",
  "ui-product-approvals": "static-1.29371",
  "ui-tool-access": "static-1.10517",
  "inbound-db-properties-service-client": "static-1.4083",
  "property-management-common": "static-1.6530",
  "opentelemetry-fe-types": "static-1.143",
  "dispatcher": "static-1.144",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.585",
  "module-federation": "static-1.34",
  "opentelemetry-fe": "static-1.518",
  "quartz-auth": "static-1.1205",
  "quartz-test": "static-1.1205",
  "quartz-tracking": "static-1.909",
  "trellis-components": "static-1.2822",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.437",
  "HubStyle": "static-2.12158",
  "bender-build-tools": "static-1.3452",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23305",
  "ContentUtils": "static-1.69238",
  "customer-data-objects-ui-components": "static-1.13392",
  "sassPrefix": "static-1.251",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.496",
  "batch-promise": "static-1.1907",
  "event-emitter": "static-1.1319",
  "fast-json-patch": "static-1.71",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5800",
  "magpie-types": "static-1.5260",
  "stylex-utils": "static-1.149",
  "trellis-theming": "static-1.1337",
  "avatar-components": "static-1.2846",
  "breeze-engine-core": "static-1.1162",
  "breeze-onboarding-components": "static-1.843",
  "customer-data-filters-ui": "static-1.41083",
  "customer-data-reference-ui-components": "static-1.13529",
  "embedded-academy-lib": "static-1.15690",
  "ExportDialog": "static-6.10741",
  "global-styles-ai-lib": "static-1.253",
  "highlight.js": "static-1.87",
  "marketplace-embed-ba": "static-1.720",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42168",
  "reporting-snowflake": "static-1.57616",
  "reporting-ui-components": "static-2.66269",
  "reporting-visualizations": "static-1.61074",
  "trial-components-library": "static-1.14202",
  "ui-addon-teams": "static-1.21963",
  "upgrade-components-lib": "static-1.591",
  "navigation-components": "static-1.18937",
  "breeze-engine-lib": "static-1.1884",
  "simple-logging-lib": "static-1.3412",
  "nudge-client-utils": "static-1.3231",
  "fail-safe": "static-1.318",
  "app-governance-lib": "static-1.2492",
  "developer-experience-shared-components": "static-1.10898",
  "purchase-motions-components": "static-1.6491",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10466",
  "usage-tracker-anonymous": "static-1.6091",
  "usage-tracker-public": "static-1.7485",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.4064",
  "reference-resolvers": "static-1.8544",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4279",
  "hubspot-apollo-cache": "static-1.695",
  "universal-page-editor-lib": "static-1.3373",
  "final-form": "static-1.79",
  "redux-toolkit": "static-1.79",
  "simple-data-table": "static-1.3615",
  "merchandise-lib": "static-1.279",
  "ui-addon-draggable": "static-3.5107",
  "content-assistance-lib": "static-1.8274",
  "content-media-capture": "static-1.5563",
  "customer-data-ui-utilities": "static-1.10192",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24622",
  "growth-payments-core": "static-1.26294",
  "knowledge-content-types": "static-1.8699",
  "PatternValidationJS": "static-1.3252",
  "payment-link-components": "static-1.24249",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20390",
  "ui-addon-emoji-picker": "static-1.10232",
  "ui-business-units-lib": "static-1.9453",
  "video-components-external": "static-1.12243",
  "video-data-lib": "static-1.35901",
  "navigation-messaging": "static-1.8264",
  "collaboration-sidebar": "static-1.58830",
  "crm-component-utils": "static-1.39956",
  "crm-properties-common-lib": "static-1.6251",
  "customer-data-properties": "static-1.52757",
  "external-options-client-types": "static-1.4377",
  "framework-data-schema-resolvers": "static-1.7255",
  "property-value-citations": "static-1.3371",
  "reference-resolvers-lite": "static-1.8465",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.66",
  "hubspotter-http-shared-msw-handlers": "static-1.10709",
  "base-ui": "static-1.23",
  "react-day-picker": "static-1.11",
  "tanstack-virtual": "static-1.39",
  "cms-field-types": "static-1.5171",
  "content-icons-ui": "static-1.2410",
  "atom": "static-1.5441",
  "idb-keyval": "static-1.52",
  "reactive-lib": "static-1.1081",
  "breeze-artifacts-sdk": "static-1.541",
  "getting-started-shared-tasks": "static-1.19353",
  "onboarding-journeys-lib": "static-1.1042",
  "onboarding-scopes": "static-1.6813",
  "conversations-skeleton-state": "static-1.7597",
  "crm-message-bus": "static-1.43876",
  "customer-data-filters-ui-msw-helpers": "static-1.23518",
  "events-data-lib": "static-1.608",
  "FormUrlGenerator": "static-2.5075",
  "framework-builder-read-service-client": "static-1.4258",
  "hs-resources": "static-1.555",
  "multi-account-reference-resolvers": "static-1.1367",
  "onboarding-tours": "static-1.17217",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14563",
  "segments-client-types": "static-1.11742",
  "academy-common-lib": "static-1.15150",
  "dashboard-lib": "static-1.83006",
  "hubspot-prosemirror-plugins": "static-1.19077",
  "share-with-third-party-component-lib": "static-1.9071",
  "ui-asset-management-lib": "static-1.11465",
  "user-context": "static-1.5471",
  "reporting-plugins": "static-1.10836",
  "reporting-reports": "static-1.68676",
  "hubs-service-types": "static-1.1622",
  "purchase-motions-api": "static-1.6494",
  "salesImages": "static-1.623",
  "signup-constants": "static-1.19719",
  "nest": "static-1.597",
  "breeze-engine-chat-components": "static-1.862",
  "ably": "static-2.2",
  "nudge-custom-function-registry": "static-1.2988",
  "nudge-renderer-utils": "static-1.3307",
  "whisper-core-api": "static-1.7434",
  "bend-plugin-fail-safe": "static-1.269",
  "framework-listing-lib": "static-2.29605",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31529",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4595",
  "signup-ui-url-generator": "static-2.8420",
  "onboarding-tours-client": "static-1.5432",
  "one-click-checkout": "static-1.541",
  "platform-infra-nav-components": "static-1.7931",
  "subscription-experience-data-types": "static-1.15303",
  "crm-record-cards-service-types": "static-1.3805",
  "location-customization-utils-lib": "static-1.10213",
  "redux-thunk": "static-2.81",
  "react-flip-move": "static-1.79",
  "ui-coaching-tips": "static-1.29409",
  "content-media-composition-data-lib": "static-1.13367",
  "fix-webm-duration": "static-1.31",
  "notification-sounds": "static-1.4784",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.823",
  "ui-addon-opt": "static-4.8716",
  "commerce-tours-lib": "static-1.6704",
  "growth-onboarding-reliability": "static-1.5443",
  "sales-checkout-service-client": "static-1.3891",
  "data-token-picker": "static-1.16966",
  "FileManagerLib": "static-1.40262",
  "content-media-compositions": "static-2.17374",
  "media-bridge-lib": "static-1.19482",
  "chatspot-widget-iframe": "static-1.23296",
  "collaboration-sidebar-common": "static-1.3627",
  "marketing-platform-lib": "static-1.7235",
  "card-properties-lib": "static-1.45117",
  "commerce-subscription-lib": "static-1.37894",
  "crm-actions": "static-1.6711",
  "crm-cards-sdk": "static-1.44722",
  "customer-data-properties-shared-msw-handlers": "static-1.10038",
  "customer-data-tracking": "static-1.7233",
  "calling-global-api": "static-1.65817",
  "calling-internal-common": "static-1.31683",
  "calling-lifecycle-internal": "static-1.67199",
  "calling-lifecycle-messages": "static-1.59493",
  "commerce-products-lib": "static-1.10657",
  "conditional-properties-service-client": "static-1.4053",
  "crm-index-visualization-core": "static-1.4609",
  "crm-links": "static-1.6663",
  "crm-pipelines-api-client-types": "static-1.4384",
  "formula-editor": "static-1.14856",
  "google-libphonenumber": "static-1.46",
  "inbounddb-objects-service-types": "static-1.4461",
  "meetings-icalendar-utils-lib": "static-1.996",
  "multi-currency-client-types": "static-1.3946",
  "object-builder-ui-client": "static-1.49802",
  "pipeline-validation-client-types": "static-1.4219",
  "smart-data-capture-core": "static-1.234",
  "smart-property-lib": "static-1.8416",
  "tiered-pricing": "static-1.2049",
  "topics-actions-lib": "static-1.532",
  "ui-addon-form-validation": "static-1.11332",
  "zustand": "static-1.86",
  "fdsr-migration-layer": "static-1.374",
  "framework-data-schema-quick-fetch": "static-1.7160",
  "restore-request-side-panel-lib": "static-1.1785",
  "growth-data-modal": "static-1.5974",
  "growth-onboarding-confetti": "static-1.3426",
  "growth-onboarding-next-action-utils": "static-1.2789",
  "onboarding-tours-utils": "static-1.1284",
  "ui-shepherd-tracker": "static-1.8013",
  "crm-index-associations-lib": "static-1.6808",
  "academy-service-client": "static-1.4054",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40121",
  "SafeStorage": "static-1.4755",
  "video-embed": "static-1.36735",
  "redux-actions": "static-3.71",
  "EmailSignatureEditor": "static-1.25074",
  "viral-links-lib": "static-1.7435",
  "nested-table": "static-1.597",
  "timezone-utils": "static-2.5592",
  "getting-started-shared-tasks-store": "static-1.18471",
  "campaign-roi-lib": "static-1.10511",
  "campaigns-utils-lib": "static-1.3589",
  "ui-addon-calendars": "static-2.5710",
  "customer-data-views-management": "static-1.26128",
  "framework-data-table": "static-2.12651",
  "nudge-custom-ui-functions": "static-1.1580",
  "switchboard-lib": "static-1.583",
  "access-check-ui-lib": "static-1.1691",
  "app-users-service-client": "static-1.5982",
  "app-users-service-types": "static-1.5390",
  "mini-checkout-client": "static-1.27636",
  "onboarding-utils": "static-1.5731",
  "permissions-shared-i18n-strings-fe": "static-1.2137",
  "ui-coaching-tips-shared-config": "static-1.29394",
  "checkout-sdk": "static-3.24479",
  "payment-method-components": "static-1.7207",
  "touchless-buying-components": "static-1.6347",
  "upgrade-catalog-service-types": "static-1.3796",
  "edison-service-client-types": "static-1.758",
  "growth-onboarding-feedback-components": "static-1.6947",
  "audio-components": "static-1.6424",
  "FileManagerImages": "static-1.37773",
  "video-components": "static-1.14245",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92965",
  "customer-data-sidebar": "static-2.46834",
  "enrichment-lib": "static-1.619",
  "ui-addon-draggable-compat": "static-2.4624",
  "universal-record-utils-lib": "static-1.2116",
  "commerce-billing-lib": "static-1.20318",
  "commerce-shared-components-lib": "static-1.19377",
  "commerce-tools-ui-lib": "static-1.11143",
  "crm-fe-perf": "static-1.23258",
  "calling-error-reporting": "static-1.31690",
  "shared-worker-versioning": "static-1.11403",
  "calling-usage-tracker": "static-1.6897",
  "voice-sms-access-library": "static-1.2182",
  "commerce-permissions": "static-1.1138",
  "products-iframe-lib": "static-1.8689",
  "products-ui-components-shared-msw-handlers": "static-1.11093",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10794",
  "sales-views-client-types": "static-1.4618",
  "bark-lib": "static-1.16887",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.728",
  "policy-lib": "static-1.7167",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10857",
  "onboarding-data-sync-lib": "static-1.2627",
  "growth-onboarding-next-action-components": "static-1.2817",
  "user-context-client": "static-1.4871",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.62",
  "urlinator": "static-1.4878",
  "outpost": "static-1.4500",
  "draft-convert": "static-2.81",
  "draft-extend": "static-3.84",
  "draft-js": "static-5.86",
  "draft-plugins": "static-2.22222",
  "sales-email-signature-service-client": "static-1.4209",
  "ts-utils-lib": "static-1.509",
  "copilot-messaging": "static-1.2195",
  "crm-export-dialog": "static-1.6646",
  "crm-index-ui-shimmer": "static-1.2790",
  "crm-view-components": "static-1.1310",
  "react-beautiful-dnd": "static-1.71",
  "customer-data-associations": "static-1.7691",
  "tasks-actions-lib": "static-1.240",
  "InboxConnectUtils": "static-4.15655",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46949",
  "hub-http-rxjs": "static-1.856",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4352",
  "company-details-components": "static-1.6568",
  "react-performance-metrics-lib": "static-1.914",
  "pricing-pages-ui-components": "static-1.16100",
  "quote-checkout-service-types": "static-1.3818",
  "social-insights-client-types": "static-1.22731",
  "crm_universal": "static-1.22557",
  "customer-data-email": "static-1.18585",
  "card-payment-highlight-lib": "static-1.38104",
  "commerce-contract-lib": "static-1.13515",
  "invoices-highlight-card-lib": "static-1.55917",
  "orders-highlight-card-lib": "static-1.22298",
  "products-highlight-card-lib": "static-1.18940",
  "quotes-highlight-card-lib": "static-1.72882",
  "crm-source-interpretation-lib": "static-1.5692",
  "data-agent-test-utils": "static-1.212",
  "data-agent-utils": "static-1.681",
  "crm-object-search-query-utilities": "static-1.10286",
  "utility-belt": "static-1.2894",
  "payments-enrollment-embed-lib": "static-1.23979",
  "stripe-embedded-components": "static-1.8073",
  "customer-data-rte": "static-1.33724",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6365",
  "payments-post-enroll-local-storage-lib": "static-1.5465",
  "qrcode-generator": "static-1.77",
  "quotes-client-types": "static-1.38972",
  "calling-orchestration-schema": "static-1.36959",
  "react-reducer-toolkit": "static-1.16462",
  "meetings-connect-utils-lib": "static-1.7973",
  "hub-http-contrib": "static-1.3388",
  "ui-addon-sales-email": "static-1.5563",
  "access-control-lib": "static-1.10787",
  "EmailComponents": "static-1.55651",
  "EmailData": "static-1.54329",
  "redux-less": "static-2.9824",
  "company-details-service-types": "static-1.4304",
  "segments-query-core": "static-1.1786",
  "pricing-pages-api": "static-1.15965",
  "sequences-lib": "static-1.8608",
  "ui-gdpr-components": "static-1.10646",
  "products-ui-components": "static-1.41175",
  "accounting-integrations-ui-components": "static-1.7617",
  "invoices-ui-lib": "static-1.55933",
  "commerce-products-api": "static-1.2759",
  "invoices-iframe-lib": "static-1.57991",
  "quotes-modal-lib": "static-1.103560",
  "quotes-ui-lib": "static-1.81603",
  "stripe-connect-js": "static-1.78",
  "draft-content-plugins": "static-1.28980",
  "ContentComponents": "static-2.72194",
  "ContentData": "static-1.69313",
  "marketing-email-service-types": "static-1.2135",
  "messaging-editing-lib": "static-1.47263",
  "messaging-usage-based-billing-components-lib": "static-1.2125",
  "automation-ui-source-apps": "static-1.19786",
  "automation-ui-types": "static-1.20704",
  "messaging-types-lib": "static-1.47000",
  "onboarding-settings-client": "static-1.4870",
  "sequences-client-types-lib": "static-1.8465",
  "commerce-tax-lib": "static-1.900",
  "price-books-api": "static-1.1832",
  "price-books-components": "static-1.1890",
  "property-description-translator": "static-1.4185",
  "ramp-editor": "static-1.983",
  "commerce-analytics-service-client": "static-1.3879",
  "totals-ui-components": "static-1.24385",
  "SalesContentIndexUI": "static-3.9676",
  "advanced-menus-core": "static-1.15652",
  "advanced-menus-lib": "static-1.12507",
  "automation-ui-ubb": "static-1.6620",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7699",
  "data-token-views": "static-1.16947",
  "forms-utils-lib": "static-1.13168",
  "payments-embed-points-lib": "static-1.13678",
  "react-tinymce": "static-1.56079",
  "simple-menus-core": "static-1.15651",
  "simple-menus-lib": "static-1.17168",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55205",
  "tinymce-data": "static-1.41290",
  "tinymce-plugins": "static-1.58319",
  "tinymce-themes": "static-1.57175",
  "ui-brand-identity-lib": "static-1.16678",
  "ui-memberships-settings-lib": "static-1.34942",
  "videoconference-integration-components": "static-1.7369",
  "automation-applications-service-types": "static-1.3667",
  "automation-platform-service-types": "static-1.2678",
  "ContentEditorUI": "static-2.78022",
  "content-whatsapp-service-types": "static-1.587",
  "short-messages-app-service-client": "static-1.4284",
  "web-interactives-components": "static-1.14323",
  "web-interactives-data": "static-1.14324",
  "messaging-shared-utils-lib": "static-1.1574",
  "messaging-user-info-utils-lib": "static-1.1744",
  "email-portal-health-service-types": "static-1.1343",
  "line-items-api": "static-1.1168",
  "commerce-totals-service-types": "static-1.4069",
  "FireAlarmUi": "static-1.4756",
  "sales-templates-service-types-lib": "static-1.4421",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22640",
  "automation-ui-usage-tracking": "static-1.22103",
  "data-studio-ubb": "static-1.3607",
  "interframe": "static-3.5104",
  "layout-dnd-components": "static-1.13049",
  "layout-dnd-utils": "static-1.12024",
  "NamespacedHubStyle": "static-2.9295",
  "campaigns-lib": "static-1.27743",
  "content-management-data-lib": "static-1.6051",
  "copilot-plugins": "static-1.11917",
  "cta-picker": "static-1.37160",
  "customer-agent-discovery-components-lib": "static-1.4069",
  "editor-components": "static-1.13728",
  "editor-iframe-lib": "static-1.8860",
  "error-messaging-js": "static-1.5547",
  "FormsCommonComponents": "static-1.86667",
  "layout-data-lib": "static-1.10349",
  "pictos": "static-7.192",
  "react-transition-group": "static-2.74",
  "redux-request-state": "static-1.10999",
  "SharedLegalStrings": "static-1.2091",
  "smart-content-core": "static-1.43271",
  "smart-content-lib": "static-1.43924",
  "social-composer-lib": "static-1.60395",
  "structured-content-lib": "static-1.26014",
  "theme-previewer-lib": "static-1.53998",
  "tinymce-copilot": "static-1.17273",
  "xray-recommendation-lib": "static-1.8329",
  "automation-ui-routing": "static-1.22061",
  "sql-reporting-client-types": "static-1.5936",
  "attribution-lib": "static-1.42867",
  "reporting-enablement": "static-1.23932",
  "forms-ai-lib": "static-1.4836",
  "codemirror-dlb": "static-1.59581",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6805",
  "report-customization-components": "static-1.14005",
  "data-quality-ui-library": "static-1.14006",
  "reporting-filters": "static-1.1096",
  "reporting-insights-lib": "static-1.2686",
  "merge-modal-lib": "static-1.12762"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13337",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.931",
  "client-types": "/client-types/static-1.501",
  "data-fetching-client": "/data-fetching-client/static-1.10011",
  "foundations-components": "/foundations-components/static-1.8578",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1603",
  "foundations-theming": "/foundations-theming/static-1.4840",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.90",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8397",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10711",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11851",
  "I18n": "/I18n/static-7.1681",
  "jasmine-runner": "/jasmine-runner/static-1.6810",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.729",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13400",
  "quartz": "/quartz/static-1.7530",
  "react-dlb": "/react-dlb/static-1.90",
  "react-rhumb": "/react-rhumb/static-1.17088",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3215",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10933",
  "reselect": "/reselect/static-3.13",
  "settings-ui-lib": "/settings-ui-lib/static-1.12885",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.184",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7702",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11510",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9892",
  "unified-auth": "/unified-auth/static-1.1022",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1304",
  "usage-tracker": "/usage-tracker/static-1.7674",
  "usage-tracker-core": "/usage-tracker-core/static-1.7524",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8449",
  "hub-http": "/hub-http/static-1.6573",
  "integrations-lib": "/integrations-lib/static-1.17181",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20848",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.834",
  "property-management-iframe": "/property-management-iframe/static-1.14242",
  "quartz-config": "/quartz-config/static-1.1308",
  "quartz-core": "/quartz-core/static-1.6749",
  "quartz-routing": "/quartz-routing/static-1.960",
  "quick-fetch": "/quick-fetch/static-1.4160",
  "react": "/react/static-7.199",
  "rpc-client-utils": "/rpc-client-utils/static-1.5027",
  "ts-schema": "/ts-schema/static-1.4330",
  "ui-universal-auth": "/ui-universal-auth/static-1.9508",
  "UIComponents": "/UIComponents/static-3.8797",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3807",
  "quartz-webpack": "/quartz-webpack/static-1.3754",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.608",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9833",
  "codemirror": "/codemirror/static-5.103",
  "foundations-assets": "/foundations-assets/static-1.5247",
  "pulse": "/pulse/static-1.993",
  "react-codemirror": "/react-codemirror/static-1.11004",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.712",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4847",
  "floating-ui": "/floating-ui/static-1.64",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2556",
  "framer-motion": "/framer-motion/static-1.80",
  "hs-story-utils": "/hs-story-utils/static-1.9785",
  "react-aria": "/react-aria/static-1.73",
  "react-create-root-preference": "/react-create-root-preference/static-1.80",
  "react-select-plus": "/react-select-plus/static-1.114",
  "react-utils": "/react-utils/static-2.5593",
  "react-virtualized": "/react-virtualized/static-2.108",
  "StyleGuideUI": "/StyleGuideUI/static-3.509",
  "tanstack-table": "/tanstack-table/static-1.62",
  "trellis-assets": "/trellis-assets/static-1.2803",
  "ui-fonts": "/ui-fonts/static-1.1113",
  "ui-images": "/ui-images/static-2.1265",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3323",
  "foundations-theming-base": "/foundations-theming-base/static-1.3825",
  "stylex": "/stylex/static-1.42",
  "HeadJS": "/HeadJS/static-2.805",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3508",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.9",
  "testing-library": "/testing-library/static-1.160",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.92",
  "jasmine": "/jasmine/static-4.4673",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9052",
  "ai-rendering-library": "/ai-rendering-library/static-1.11200",
  "chirp-fetch": "/chirp-fetch/static-1.2259",
  "connections-embed-lib": "/connections-embed-lib/static-1.1591",
  "copilot-toolkit": "/copilot-toolkit/static-1.11945",
  "feedback-loader": "/feedback-loader/static-1.29890",
  "laboratory-lib": "/laboratory-lib/static-3.7514",
  "marketplace-embed": "/marketplace-embed/static-1.23017",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10743",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20803",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15018",
  "sanitize-text": "/sanitize-text/static-1.8518",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6088",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5360",
  "wootric-nps": "/wootric-nps/static-1.7232",
  "quartz-head": "/quartz-head/static-1.1195",
  "web-vitals": "/web-vitals/static-1.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5008",
  "immer": "/immer/static-1.102",
  "immerable": "/immerable/static-1.4506",
  "highcharts": "/highcharts/static-8.112",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2733",
  "reporting-data": "/reporting-data/static-1.69000",
  "cssUtils": "/cssUtils/static-1.983",
  "flux-actions": "/flux-actions/static-1.375",
  "react-colorpicker": "/react-colorpicker/static-2.10575",
  "react-dnd-compat": "/react-dnd-compat/static-1.4976",
  "redux-observable": "/redux-observable/static-1.76",
  "ReduxMessenger": "/ReduxMessenger/static-2.10733",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7664",
  "icons": "/icons/static-2.695",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19380",
  "storybook-react": "/storybook-react/static-1.41",
  "trellis-story-utils": "/trellis-story-utils/static-1.4868",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6061",
  "quartz-i18n": "/quartz-i18n/static-1.1205",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.569",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1587",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.72",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1132",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.271",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.608",
  "slack-ui-library": "/slack-ui-library/static-1.10760",
  "fsm": "/fsm/static-1.4115",
  "customer-data-objects": "/customer-data-objects/static-1.8052",
  "property-translator": "/property-translator/static-1.5742",
  "hs-locale-management": "/hs-locale-management/static-1.332",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8282",
  "hs-promise-utils": "/hs-promise-utils/static-1.5951",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5236",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14596",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5973",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8127",
  "sanitize": "/sanitize/static-1.4832",
  "superstore": "/superstore/static-1.5122",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10632",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8419",
  "hub-http-janus": "/hub-http-janus/static-1.889",
  "hubspotter-http": "/hubspotter-http/static-1.4896",
  "immutable-less": "/immutable-less/static-1.5012",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18255",
  "nav-meta": "/nav-meta/static-1.30574",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18454",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1266",
  "ai-studio-lib": "/ai-studio-lib/static-1.12525",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19085",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.564",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9440",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8378",
  "ui-product-approvals": "/ui-product-approvals/static-1.29371",
  "ui-tool-access": "/ui-tool-access/static-1.10517",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4083",
  "property-management-common": "/property-management-common/static-1.6530",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.143",
  "dispatcher": "/dispatcher/static-1.144",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.585",
  "module-federation": "/module-federation/static-1.34",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.518",
  "quartz-auth": "/quartz-auth/static-1.1205",
  "quartz-test": "/quartz-test/static-1.1205",
  "quartz-tracking": "/quartz-tracking/static-1.909",
  "trellis-components": "/trellis-components/static-1.2822",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.437",
  "HubStyle": "/HubStyle/static-2.12158",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23305",
  "ContentUtils": "/ContentUtils/static-1.69238",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13392",
  "sassPrefix": "/sassPrefix/static-1.251",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.496",
  "batch-promise": "/batch-promise/static-1.1907",
  "event-emitter": "/event-emitter/static-1.1319",
  "fast-json-patch": "/fast-json-patch/static-1.71",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5800",
  "magpie-types": "/magpie-types/static-1.5260",
  "stylex-utils": "/stylex-utils/static-1.149",
  "trellis-theming": "/trellis-theming/static-1.1337",
  "avatar-components": "/avatar-components/static-1.2846",
  "breeze-engine-core": "/breeze-engine-core/static-1.1162",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.843",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41083",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13529",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15690",
  "ExportDialog": "/ExportDialog/static-6.10741",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.253",
  "highlight.js": "/highlight.js/static-1.87",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.720",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42168",
  "reporting-snowflake": "/reporting-snowflake/static-1.57616",
  "reporting-ui-components": "/reporting-ui-components/static-2.66269",
  "reporting-visualizations": "/reporting-visualizations/static-1.61074",
  "trial-components-library": "/trial-components-library/static-1.14202",
  "ui-addon-teams": "/ui-addon-teams/static-1.21963",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.591",
  "navigation-components": "/navigation-components/static-1.18937",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1884",
  "simple-logging-lib": "/simple-logging-lib/static-1.3412",
  "nudge-client-utils": "/nudge-client-utils/static-1.3231",
  "fail-safe": "/fail-safe/static-1.318",
  "app-governance-lib": "/app-governance-lib/static-1.2492",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10898",
  "purchase-motions-components": "/purchase-motions-components/static-1.6491",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10466",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6091",
  "usage-tracker-public": "/usage-tracker-public/static-1.7485",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.4064",
  "reference-resolvers": "/reference-resolvers/static-1.8544",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4279",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.695",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3373",
  "final-form": "/final-form/static-1.79",
  "redux-toolkit": "/redux-toolkit/static-1.79",
  "simple-data-table": "/simple-data-table/static-1.3615",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5107",
  "content-assistance-lib": "/content-assistance-lib/static-1.8274",
  "content-media-capture": "/content-media-capture/static-1.5563",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10192",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24622",
  "growth-payments-core": "/growth-payments-core/static-1.26294",
  "knowledge-content-types": "/knowledge-content-types/static-1.8699",
  "PatternValidationJS": "/PatternValidationJS/static-1.3252",
  "payment-link-components": "/payment-link-components/static-1.24249",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20390",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10232",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9453",
  "video-components-external": "/video-components-external/static-1.12243",
  "video-data-lib": "/video-data-lib/static-1.35901",
  "navigation-messaging": "/navigation-messaging/static-1.8264",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58830",
  "crm-component-utils": "/crm-component-utils/static-1.39956",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6251",
  "customer-data-properties": "/customer-data-properties/static-1.52757",
  "external-options-client-types": "/external-options-client-types/static-1.4377",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7255",
  "property-value-citations": "/property-value-citations/static-1.3371",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8465",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.66",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10709",
  "base-ui": "/base-ui/static-1.23",
  "react-day-picker": "/react-day-picker/static-1.11",
  "tanstack-virtual": "/tanstack-virtual/static-1.39",
  "cms-field-types": "/cms-field-types/static-1.5171",
  "content-icons-ui": "/content-icons-ui/static-1.2410",
  "atom": "/atom/static-1.5441",
  "idb-keyval": "/idb-keyval/static-1.52",
  "reactive-lib": "/reactive-lib/static-1.1081",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.541",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19353",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1042",
  "onboarding-scopes": "/onboarding-scopes/static-1.6813",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7597",
  "crm-message-bus": "/crm-message-bus/static-1.43876",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23518",
  "events-data-lib": "/events-data-lib/static-1.608",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5075",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4258",
  "hs-resources": "/hs-resources/static-1.555",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1367",
  "onboarding-tours": "/onboarding-tours/static-1.17217",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14563",
  "segments-client-types": "/segments-client-types/static-1.11742",
  "academy-common-lib": "/academy-common-lib/static-1.15150",
  "dashboard-lib": "/dashboard-lib/static-1.83006",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19077",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9071",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11465",
  "user-context": "/user-context/static-1.5471",
  "reporting-plugins": "/reporting-plugins/static-1.10836",
  "reporting-reports": "/reporting-reports/static-1.68676",
  "hubs-service-types": "/hubs-service-types/static-1.1622",
  "purchase-motions-api": "/purchase-motions-api/static-1.6494",
  "salesImages": "/salesImages/static-1.623",
  "signup-constants": "/signup-constants/static-1.19719",
  "nest": "/nest/static-1.597",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.862",
  "ably": "/ably/static-2.2",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2988",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3307",
  "whisper-core-api": "/whisper-core-api/static-1.7434",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.269",
  "framework-listing-lib": "/framework-listing-lib/static-2.29605",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31529",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4595",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8420",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5432",
  "one-click-checkout": "/one-click-checkout/static-1.541",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7931",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15303",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3805",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10213",
  "redux-thunk": "/redux-thunk/static-2.81",
  "react-flip-move": "/react-flip-move/static-1.79",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29409",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13367",
  "fix-webm-duration": "/fix-webm-duration/static-1.31",
  "notification-sounds": "/notification-sounds/static-1.4784",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.823",
  "ui-addon-opt": "/ui-addon-opt/static-4.8716",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6704",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5443",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3891",
  "data-token-picker": "/data-token-picker/static-1.16966",
  "FileManagerLib": "/FileManagerLib/static-1.40262",
  "content-media-compositions": "/content-media-compositions/static-2.17374",
  "media-bridge-lib": "/media-bridge-lib/static-1.19482",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23296",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3627",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7235",
  "card-properties-lib": "/card-properties-lib/static-1.45117",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37894",
  "crm-actions": "/crm-actions/static-1.6711",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44722",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10038",
  "customer-data-tracking": "/customer-data-tracking/static-1.7233",
  "calling-global-api": "/calling-global-api/static-1.65817",
  "calling-internal-common": "/calling-internal-common/static-1.31683",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67199",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59493",
  "commerce-products-lib": "/commerce-products-lib/static-1.10657",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4053",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4609",
  "crm-links": "/crm-links/static-1.6663",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4384",
  "formula-editor": "/formula-editor/static-1.14856",
  "google-libphonenumber": "/google-libphonenumber/static-1.46",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4461",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.996",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3946",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49802",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4219",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.234",
  "smart-property-lib": "/smart-property-lib/static-1.8416",
  "tiered-pricing": "/tiered-pricing/static-1.2049",
  "topics-actions-lib": "/topics-actions-lib/static-1.532",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11332",
  "zustand": "/zustand/static-1.86",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.374",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7160",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1785",
  "growth-data-modal": "/growth-data-modal/static-1.5974",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3426",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2789",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1284",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8013",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6808",
  "academy-service-client": "/academy-service-client/static-1.4054",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40121",
  "SafeStorage": "/SafeStorage/static-1.4755",
  "video-embed": "/video-embed/static-1.36735",
  "redux-actions": "/redux-actions/static-3.71",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25074",
  "viral-links-lib": "/viral-links-lib/static-1.7435",
  "nested-table": "/nested-table/static-1.597",
  "timezone-utils": "/timezone-utils/static-2.5592",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18471",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10511",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3589",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5710",
  "customer-data-views-management": "/customer-data-views-management/static-1.26128",
  "framework-data-table": "/framework-data-table/static-2.12651",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1580",
  "switchboard-lib": "/switchboard-lib/static-1.583",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1691",
  "app-users-service-client": "/app-users-service-client/static-1.5982",
  "app-users-service-types": "/app-users-service-types/static-1.5390",
  "mini-checkout-client": "/mini-checkout-client/static-1.27636",
  "onboarding-utils": "/onboarding-utils/static-1.5731",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2137",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29394",
  "checkout-sdk": "/checkout-sdk/static-3.24479",
  "payment-method-components": "/payment-method-components/static-1.7207",
  "touchless-buying-components": "/touchless-buying-components/static-1.6347",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3796",
  "edison-service-client-types": "/edison-service-client-types/static-1.758",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6947",
  "audio-components": "/audio-components/static-1.6424",
  "FileManagerImages": "/FileManagerImages/static-1.37773",
  "video-components": "/video-components/static-1.14245",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92965",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46834",
  "enrichment-lib": "/enrichment-lib/static-1.619",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4624",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2116",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20318",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19377",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11143",
  "crm-fe-perf": "/crm-fe-perf/static-1.23258",
  "calling-error-reporting": "/calling-error-reporting/static-1.31690",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11403",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6897",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2182",
  "commerce-permissions": "/commerce-permissions/static-1.1138",
  "products-iframe-lib": "/products-iframe-lib/static-1.8689",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11093",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10794",
  "sales-views-client-types": "/sales-views-client-types/static-1.4618",
  "bark-lib": "/bark-lib/static-1.16887",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.728",
  "policy-lib": "/policy-lib/static-1.7167",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10857",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2627",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2817",
  "user-context-client": "/user-context-client/static-1.4871",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.62",
  "urlinator": "/urlinator/static-1.4878",
  "outpost": "/outpost/static-1.4500",
  "draft-convert": "/draft-convert/static-2.81",
  "draft-extend": "/draft-extend/static-3.84",
  "draft-js": "/draft-js/static-5.86",
  "draft-plugins": "/draft-plugins/static-2.22222",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4209",
  "ts-utils-lib": "/ts-utils-lib/static-1.509",
  "copilot-messaging": "/copilot-messaging/static-1.2195",
  "crm-export-dialog": "/crm-export-dialog/static-1.6646",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2790",
  "crm-view-components": "/crm-view-components/static-1.1310",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.71",
  "customer-data-associations": "/customer-data-associations/static-1.7691",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.240",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15655",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46949",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.856",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4352",
  "company-details-components": "/company-details-components/static-1.6568",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.914",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16100",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3818",
  "social-insights-client-types": "/social-insights-client-types/static-1.22731",
  "crm_universal": "/crm_universal/static-1.22557",
  "customer-data-email": "/customer-data-email/static-1.18585",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38104",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13515",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55917",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22298",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18940",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72882",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5692",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.212",
  "data-agent-utils": "/data-agent-utils/static-1.681",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10286",
  "utility-belt": "/utility-belt/static-1.2894",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23979",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8073",
  "customer-data-rte": "/customer-data-rte/static-1.33724",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6365",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5465",
  "qrcode-generator": "/qrcode-generator/static-1.77",
  "quotes-client-types": "/quotes-client-types/static-1.38972",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36959",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16462",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7973",
  "hub-http-contrib": "/hub-http-contrib/static-1.3388",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5563",
  "access-control-lib": "/access-control-lib/static-1.10787",
  "EmailComponents": "/EmailComponents/static-1.55651",
  "EmailData": "/EmailData/static-1.54329",
  "redux-less": "/redux-less/static-2.9824",
  "company-details-service-types": "/company-details-service-types/static-1.4304",
  "segments-query-core": "/segments-query-core/static-1.1786",
  "pricing-pages-api": "/pricing-pages-api/static-1.15965",
  "sequences-lib": "/sequences-lib/static-1.8608",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10646",
  "products-ui-components": "/products-ui-components/static-1.41175",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7617",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55933",
  "commerce-products-api": "/commerce-products-api/static-1.2759",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57991",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103560",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81603",
  "stripe-connect-js": "/stripe-connect-js/static-1.78",
  "draft-content-plugins": "/draft-content-plugins/static-1.28980",
  "ContentComponents": "/ContentComponents/static-2.72194",
  "ContentData": "/ContentData/static-1.69313",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2135",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47263",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2125",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19786",
  "automation-ui-types": "/automation-ui-types/static-1.20704",
  "messaging-types-lib": "/messaging-types-lib/static-1.47000",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4870",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8465",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.900",
  "price-books-api": "/price-books-api/static-1.1832",
  "price-books-components": "/price-books-components/static-1.1890",
  "property-description-translator": "/property-description-translator/static-1.4185",
  "ramp-editor": "/ramp-editor/static-1.983",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3879",
  "totals-ui-components": "/totals-ui-components/static-1.24385",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9676",
  "advanced-menus-core": "/advanced-menus-core/static-1.15652",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12507",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6620",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7699",
  "data-token-views": "/data-token-views/static-1.16947",
  "forms-utils-lib": "/forms-utils-lib/static-1.13168",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13678",
  "react-tinymce": "/react-tinymce/static-1.56079",
  "simple-menus-core": "/simple-menus-core/static-1.15651",
  "simple-menus-lib": "/simple-menus-lib/static-1.17168",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55205",
  "tinymce-data": "/tinymce-data/static-1.41290",
  "tinymce-plugins": "/tinymce-plugins/static-1.58319",
  "tinymce-themes": "/tinymce-themes/static-1.57175",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16678",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34942",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7369",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3667",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2678",
  "ContentEditorUI": "/ContentEditorUI/static-2.78022",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.587",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4284",
  "web-interactives-components": "/web-interactives-components/static-1.14323",
  "web-interactives-data": "/web-interactives-data/static-1.14324",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1574",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1744",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1343",
  "line-items-api": "/line-items-api/static-1.1168",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4069",
  "FireAlarmUi": "/FireAlarmUi/static-1.4756",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4421",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22640",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22103",
  "data-studio-ubb": "/data-studio-ubb/static-1.3607",
  "interframe": "/interframe/static-3.5104",
  "layout-dnd-components": "/layout-dnd-components/static-1.13049",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12024",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9295",
  "campaigns-lib": "/campaigns-lib/static-1.27743",
  "content-management-data-lib": "/content-management-data-lib/static-1.6051",
  "copilot-plugins": "/copilot-plugins/static-1.11917",
  "cta-picker": "/cta-picker/static-1.37160",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4069",
  "editor-components": "/editor-components/static-1.13728",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8860",
  "error-messaging-js": "/error-messaging-js/static-1.5547",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86667",
  "layout-data-lib": "/layout-data-lib/static-1.10349",
  "pictos": "/pictos/static-7.192",
  "react-transition-group": "/react-transition-group/static-2.74",
  "redux-request-state": "/redux-request-state/static-1.10999",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2091",
  "smart-content-core": "/smart-content-core/static-1.43271",
  "smart-content-lib": "/smart-content-lib/static-1.43924",
  "social-composer-lib": "/social-composer-lib/static-1.60395",
  "structured-content-lib": "/structured-content-lib/static-1.26014",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53998",
  "tinymce-copilot": "/tinymce-copilot/static-1.17273",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8329",
  "automation-ui-routing": "/automation-ui-routing/static-1.22061",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5936",
  "attribution-lib": "/attribution-lib/static-1.42867",
  "reporting-enablement": "/reporting-enablement/static-1.23932",
  "forms-ai-lib": "/forms-ai-lib/static-1.4836",
  "codemirror-dlb": "/codemirror-dlb/static-1.59581",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6805",
  "report-customization-components": "/report-customization-components/static-1.14005",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.14006",
  "reporting-filters": "/reporting-filters/static-1.1096",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2686",
  "merge-modal-lib": "/merge-modal-lib/static-1.12762"
}
};
